module.exports = __webpack_public_path__ + "img/2018-08-01.c679ddc4.jpg";